import { Route } from 'app/enums';
import { TournamentEntity } from 'app/interfaces/entity';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { generatePath } from 'react-router-dom';
import { currentTournamentSelector } from '../store/current-tournament/selectors';

export const useSharedLink = (): string => {
  const tournament: TournamentEntity = useSelector(currentTournamentSelector.tournament);
  const isKnockOutTournament = useSelector(currentTournamentSelector.isKnockOutTournament);

  return useMemo(() => {
    if (!tournament?.id) {
      return '';
    }

    if (isKnockOutTournament) {
      return `${window.location.origin}${generatePath(Route.TournamentOverview, {
        id: tournament.id,
      })}`;
    }

    return `${window.location.origin}?tournamentId=${tournament.id}`;
  }, [isKnockOutTournament, tournament.id]);
};
